<template>
  <div>
    <el-form label-width="100px" label-position="left">
      <el-form-item label="分组搜索">
        <el-select v-model="group.id" @change="selectGroup">
          <el-option value="0" label="全部"></el-option>
          <el-option value="areaName" label="设备所在地"></el-option>
          <el-option value="room" label="所属机房"></el-option>
        </el-select>
        <el-select v-model="group.listVal" class="marginLeft">
          <el-option value="全部" label="全部"></el-option>
          <el-option v-for="(option, index) in group.list" :key="index"
                     :label="option.name" :value="option.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input placeholder="请输入搜索关键字" v-model="searchKey" style="width:30%;"></el-input>
        <!-- <el-button type="primary" class="marginLeft" @click="getServerList">搜索</el-button> -->
      </el-form-item>
    </el-form>
    <div class="cardContainer">
      <div class="cardItem" v-for="(item, index) in filterList" :key="index">
        <server-card :server="item" :listOperations="listOperations"/>
      </div>
    </div>
  </div>
</template>
<script>
import {Loading} from "element-ui";
import ServerCard from './ServerCard.vue'
import {mapMutations, mapState} from "vuex";

export default {
  name: 'MonitorManager',
  components: {ServerCard},
  data: vm => ({
    //查询分组
    group: {
      id: '0', //分组id
      listVal: '全部', // 分组后的选项值
      list: [],
      area: [], //所在地
      room: [], //机房
    },
    serverList: [],
    searchKey: '',
    netCardInfoList: []
  }),
  created() {
    this.getListOperations('monitor/manager');
    if (!this.currentMenu) {
      return
    }
    this.getServerList();
    this.getNetcardInfo();
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    // 操作按钮是否显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
        }

      }
    },
    filterList() {
      let _this = this
      let datas = [].concat(this.serverList)


      let arr = []
      const value = this.searchKey
      if (this.group.listVal != '全部') {
        if (value) {
          arr = datas.filter(sl => {
            return ((sl[this.group.id] == this.group.listVal)
              &&
              _this.searchCondition(value, sl)
            )
          })
        } else {
          arr = datas.filter(sl => sl[this.group.id] == this.group.listVal)
        }
      } else {
        if (value) {
          arr = datas.filter(sl => {
            return _this.searchCondition(value, sl)
          })
        } else {
          arr = datas
        }
      }


      if (arr && arr.length > 0) {
        arr.forEach(e => {
          this.netCardInfoList.forEach(item => {
            if (e.deviceId == item.id) {
              e.networkCards = item.networkCards
            }
          })

        })
      }
      return arr
    },
  },
  methods: {
    ...mapMutations(['getListOperations']),
    // 按照关键字搜索
    searchCondition(val, obj) {
      let hasData = false
      if (obj.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
        hasData = true
      } else if (obj.networkCards) {
        for (let nt of obj.networkCards) {
          if (nt.innerNetwork && nt.innerNetwork.ip && nt.innerNetwork.ip.indexOf(val) > -1) {
            hasData = true
            break
          }
          if (nt.outerNetwork && nt.outerNetwork.ip && nt.outerNetwork.ip.indexOf(val) > -1) {
            hasData = true
            break
          }
        }
      }
      return hasData
    },
    selectGroup(id) {
      // 重置筛选框
      this.group.listVal = '全部'
      if (id == '0') {
        this.group.list = []
        this.group.listVal = '全部'
      } else if (id == 'areaName') {
        this.group.list = this.group.area
      } else {
        this.group.list = this.group.room
      }
    },
    // 获取设备列表
    getServerList() {
      const _this = this

      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + 'management3/device/statByDevice')
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.serverList = data ? data : []
            this.serverList.forEach(sl => {
              let str = "";
              if (sl.area.dNameCity) {
                str = sl.area.dNameCountry + "·" + sl.area.dNameProvince + "·" + sl.area.dNameCity
              } else {
                if (sl.area.dNameProvince) {
                  str=sl.area.dNameCountry + "·" + sl.area.dNameProvince
                }else {
                  str=sl.area.dNameCountry
                }
              }

              sl.areaName = sl.area.dNameCountry ? str : "未设置"


              const areaIn = _this.group.area.some(a => a.name == sl.areaName)

              const roomIn = _this.group.room.some(a => a.name == sl.room)
              if (!areaIn) {
                _this.group.area.push({
                  // name: sl.area
                  name: sl.areaName
                })
              }
              if (!roomIn) {
                _this.group.room.push({
                  name: sl.room
                })
              }
            })
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
          }
          loading.close()
        })
        .catch(err => {
          console.log(err)
          loading.close()
        })
    },
    // 获取设备列表
    getNetcardInfo() {
      const _this = this

      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + 'management3/device/netCard/findAll')
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              _this.netCardInfoList = data;
            } else {
              _this.netCardInfoList = [];
            }
          }
          loading.close()
        })
        .catch(err => {
          console.log(err)
          loading.close()
        })
    }
  }
}
</script>
<style scoped>
.cardContainer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.cardItem {
  width: 48%;
  margin-bottom: 20px;
}

.marginLeft {
  margin-left: 10px;
}
</style>
